<template>
	<b-modal ref="profile_modal"
			 size="lg"
			 bodyClass="p-0"
			 v-bind:no-close-on-backdrop=true
			 :hide-header=true
			 v-model="is_show_modal"
			 :dialogClass=dialog_class_draw>

		<template v-slot:modal-header="{ close }">
			<!-- Emulate built in modal header close button action -->
			<b-button size="sm" variant="outline-danger" @click="close()">
				Close Modal
			</b-button>
		</template>

		<!-- BODY -->
		<div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
			<div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
				<h2 >
					<span class="fw-300">ID:{{this.product.id}}</span>
				</h2>
				<div class="panel-toolbar pr-3 pb-2 align-self-end">
					<button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
						<i class="fal fa-times"></i>
					</button>
				</div>
			</div>

			<div class="panel-container show">
				<b-overlay :show="is_load" rounded="sm">
					<div class="panel-content" v-if="product.id >= 0">
						<div class="d-flex flex-column align-items-center justify-content-center p-4">
							<h5 class="mb-0 fw-700 text-center mt-3">
								{{this.product.title}}

							</h5>
						</div>
						<div>
							<b-tabs content-class="mt-3">
								<b-tab v-for="(tab,index) in tabs" @click="set_active(index)"
									   :disabled="tab.disabled"
									   :title="get_tab_title(tab)"
									   :key="index"
									   :active="tab.is_active"
								>
									<template slot="title">
										{{get_tab_title(tab)}}
										<b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
									</template>

									<component
                                        :product_type="item_type"
                                        v-bind:is="tab.index"
                                        :product="product"
                                        @on_change="set_product_param">
                                    </component>
								</b-tab>
							</b-tabs>
						</div>
					</div>
				</b-overlay>
			</div>
		</div>
		<template v-slot:modal-footer="{close}">
			<div class="modal-footer">
                <button type="button" @click="remove(false)" class="btn btn-outline-danger waves-effect waves-themed mr-5 pl-5 pr-5" v-if="product.id > 0">
                    {{ __t('REMOVE') }}
                </button>

				<button type="button" @click="close()" class="btn btn-secondary waves-effect waves-themed">
					{{__t('CLOSE')}}
				</button>

				<button type="button" v-on:click="save_product" class="btn btn-primary waves-effect waves-themed">
					{{__t('SAVE')}}
				</button>
			</div>
		</template>

	</b-modal>
</template>
<script>
import Info_field from "../../../sys/info_field";
import product_info from "./tabs/product_info";
import product_images from "./tabs/product_images";
import product_restaurants from "./tabs/product_restaurants";
import product_prices from "./tabs/product_prices";
import product_settings from "./tabs/product_settings";
import product_categories from "./tabs/product_categories";
import product_custom_modification from "./tabs/product_custom_modification";
import product_translate from "./tabs/product_translate";
import product_advanced from "./tabs/product_advanced.vue";
//import product_combo from "./tabs/product_combo.vue";


export default {
	name: "product_modal",
	components: {
		product_settings,
		product_prices,
		product_restaurants,
		product_info,
		Info_field,
		product_images,
		product_categories,
        product_custom_modification,
        product_translate,
        product_advanced,
     //   product_combo

	},
	props: {
		modal_position: {
			type: String,
			default: "left"
		},
	},
	data() {
		return {
			is_show_modal: false,
			is_load_adv: false,
			is_load: false,
            item_type : "product",
			product: {
				id: 0,
				title: "",
				uniq_id: "",
				provider_rest_save : [],
			},
			tabs: []
		}
	},
	created() {
		EventBus.$on("product_edit", res => this.work_click(res,'product'));
        EventBus.$on("combo_edit", res => this.work_click(res,'combo'));
		EventBus.$on("close_product",this.close);
	},
	methods : {

		get_tab_title (tab) {
			if(tab.count > 0) {
				return tab.title;
			}
			return tab.title;
		},

		set_active (obj) {
			for (let tab in this.tabs) {
				this.tabs[tab].is_active = false;
			}

			this.tabs[obj].is_active = true;
			EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
		},

		async init_tabs () {

		},

        set_product_param(type,param) {
            this.product[type] = param;
        },

		async load_product(product_id)
		{
			this.tabs = [];
			this.is_load = true;

            let url = '/internal/v1/catalog/products/';
			await api.get(url + product_id).then(({data}) => {
				this.is_load = false;
                let prod_type = data.data.type;
                if(prod_type === 'combo') {
                    this.item_type = prod_type;
                }

                this.push_tabs();

				if (data.status === "operation_success") {
					this.product = data.data;
				} else {
					this.product = this.dfault_prod;
				}
			}).catch(({response}) => {
				this.is_load = false;
				this.product = this.dfault_prod;
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
			});
		},

        remove() {
            let self = this;
            const is_ok = confirm_me(this.__t("ARE_SURE"));
            is_ok.then(res => {
                self.is_load = true;
                api.delete('/internal/v1/catalog/products/' + this.product.id).then(({data}) => {
                    self.is_load = false;
                    if (data.status === "operation_success") {
                        self.close();
                        EventBus.$emit("reload_products");
                    }
                }).catch(({response}) => {
                    self.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message, type: "danger",
                        title: response.data.status,
                        position : "b-toaster-top-left"
                    })
                });
            });
        },

		close() {
			this.product = this.dfault_prod;
			this.tabs = [];
			this.is_show_modal = false;
		},

		work_click(prod_id,type) {
            this.item_type = type;
			this.product = this.dfault_prod;
			this.is_show_modal = true;
			this.load_product(prod_id)
		},

		save_product() {
			EventBus.$emit("save_product_called");
		},

        push_tabs() {
            this.default_tabs.map(item => {
                this.tabs.push({
                    title: item.title,
                    disabled: false,
                    is_active: false,
                    is_load: false,
                    index: item.index,
                    html: ''
                });
            });
        },
	},
	computed : {

        default_tabs() {
            let base = [
                {
                    "title": this.__t('MAIN_SETTINGS'),
                    "index": "product_info",
                    is_active:true,
                },
                {
                    "title": this.__t('ADVANCED_SETTINGS'),
                    "index": "product_settings",
                    is_active:false,
                },
                {
                    "title": this.__t('PRODUCT_INFO'),
                    "index": "product_advanced",
                    is_active:false,
                },
                {
                    "title": this.__t('PRICE'),
                    "index": "product_prices",
                    is_active:false,
                },

                {
                    "title": this.__t('PRODUCT.CATEGORIES'),
                    "index": "product_categories",
                    is_active:false,
                },

                {
                    "title": this.__t('PHOTO'),
                    "index": "product_images",
                    is_active:false,
                },

                {
                    "title": this.__t('PRODUCT_MODIFIERS'),
                    "index": "product_custom_modification",
                    is_active:false,
                },
                {
                    "title": this.__t('PRODUCT.LANGUAGE'),
                    "index": "product_translate",
                    is_active:false,
                },
                {
                    "title": this.__t('PRODUCT.RESTAURANT'),
                    "index": "product_restaurants",
                    is_active:false,
                },
            ];

            if(this.item_type === 'combo') {
                base = base.map(item => {
                    if(item.index === 'product_custom_modification')  {
                        item.title = this.__t('PRODUCT.COMBO');
                    }

                    return item;
                });
            }

            if(this.product.id === 0 ) {
                /*base = base.filter(item => {
                    if(item.index == 'product_advanced') {
                        return false;
                    }

                    if(item.index == 'product_custom_modification') {

                    }

                    if(item.index == 'product_images') {

                    }

                    return item.index !== 'product_advanced';
                });*/
            }


            return base;
        },


		dfault_prod () {
			return {
				id: 0,
				title: "",
				uniq_id: "",
			}
		},

		dialog_class_draw () {
			if(this.modal_position === "left") {
				return "modal-dialog-left modal-xl";
			}

			return "modal-dialog-right modal-lg";
		},
	}

}
</script>

<style scoped>

</style>
